function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 43.31,
  fill: "#b7b7b7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M73.24,12.17a43.31,43.31,0,0,1-62.74,59,43.31,43.31,0,1,0,62.74-59Z",
  fill: "#aaa"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1,62.49c7.36-6.82,23.5-17.38,40.37.11a2.54,2.54,0,0,1-1.79,4.3s-20.79-4.31-36.9,0C25.21,67.31,23.41,64.05,25.1,62.49Z",
  fill: "#838383"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 60.75,
  cy: 35.02,
  r: 6.31,
  fill: "#838383"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.25,
  cy: 35.02,
  r: 6.31,
  fill: "#838383"
});

function SvgFace1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1);
export default __webpack_public_path__ + "static/media/face_1.e8a5b51a.svg";
export { ForwardRef as ReactComponent };